export enum AnalyticsCategory {
  interaction = 'interaction',
  page = 'page',
}
